import { SHIPPER_INFOR_SUCCESS } from '../actions/shipperInfor';
import * as AddOrder from './../actions/addOrder';
import lang from './../languages/en';
import { alertSuccess } from './../services/dialog';
import { regexJapanese, regexName } from './../services/ruleValidate';
import { informationClassesDefault, informationDefault } from './helper/stateDefaultOrder';

const stateDefaultAddOrder = () => {
    return {
        request: false,
        confirm_save_order: false,
        search_item_code: false,
        selected_item_code: '',
        row_item: '',
        search_origin: false,
        selected_origin: '',
        checked_all_items: false,
        message: '',
        error: [],
        tooltip: '',
        deleteDisable: true,
        dumplicateValueItem: 0,
        rowItemError: [],
        focusName: false,
        focusPostalCode: false,
        settingMappingItemName: null,
        dataMappingItem: null,
        modalMappingItem: false,
        modalTypeMappingItem: false,
        buttonAddOrUpdateMapping: true,
        mappingOrderSameSku: 3,
        SKUDuplicateOrderOther: false
    }
}

const initialState = {
    information: informationDefault(),
    shipperInformation: {},
    classes: informationClassesDefault(),
    items: [],
    shipperInfor: [],
    isLoading: false,
    isLoadingItemName: false,
    ...stateDefaultAddOrder()
}

export default (state = initialState, action) => {
    switch (action.type) {
        case AddOrder.ON_CHANGE_INFORMATION:
            return {
                ...state,
                information: {
                    ...state.information,
                    [action.payload.column]: action.payload.value
                }
            }

        case AddOrder.STATE_INFORMATION_DEFAULT:
            return {
                ...state,
                information: action.payload,
                ...stateDefaultAddOrder()
            }

        case AddOrder.STATE_INFORMATION_CLASSES_DEFAULT:
            return {
                ...state,
                classes: action.payload
            }

        case AddOrder.ON_CHANGE_ITEM:
            return {
                ...state,
                items: [...action.payload]
            }

        case AddOrder.CHECKED_ALL_ITEMS:
            return {
                ...state,
                items: [...action.payload.items],
                checked_all_items: action.payload.checked_all
            }

        case AddOrder.ON_CHANGE_CLASSES:
            return {
                ...state,
                classes: { ...action.payload },
            }

        case AddOrder.ADD_ORDER:
            return {
                ...state,
                isDisable: true
            }

        case AddOrder.ADD_ORDER_SUCCESS:
            alertSuccess(lang.create_order_success)
            return {
                ...state,
                isLoading: false
            }

        case AddOrder.ADD_ORDER_FAILS:
            if (action.payload.data.code === 211140) {
                state.classes.channel_order = 'error'
            }

            return {
                ...state,
                isLoading: false
            }

        case AddOrder.ON_CHANGE_ADD_ORDER:
            return {
                ...state,
                [action.payload.column]: action.payload.value
            }

        case AddOrder.SEARCH_ITEM_CODE:
            return {
                ...state,
                [action.payload.column]: action.payload.value,
                row_item: action.payload.rowItem
            }

        case AddOrder.CHECK_POSTAL_CODE_SUCCESS:
            let address = action.payload.data.data

            const { address1, address2, address3, address4 } = state.information
            if (!address1 && !address2 && !address3 && !address4) {
                state.information.address1 = address.Add1
                state.information.address2 = address.Add2
                state.information.address3 = address.Add3
            }

            if (address.Add1 || address.Add2 || address.Add3) {
                state.classes.postal_code = ''
            } else {
                state.classes.postal_code = 'warring'
            }

            if (state.information.address1) {
                state.classes.address1 = ''
            } else {
                state.classes.address1 = 'error'
            }

            if (state.information.address2) {
                state.classes.address2 = ''
            } else {
                state.classes.address2 = 'error'
            }

            return {
                ...state
            }

        case AddOrder.CHECK_POSTAL_CODE_FAILS:
            return {
                ...state,
                isLoading: false
            }

        case SHIPPER_INFOR_SUCCESS:
            let shipperInfor = action.payload.data.data
            return {
                ...state,
                information: {
                    ...state.information,
                    currency: shipperInfor.DefaultCurrencyCH,
                    terms: shipperInfor.DefaultPaymentTermCH
                },
                shipperInformation: {
                    currency: shipperInfor.DefaultCurrencyCH,
                    defaultPaymentTerm: shipperInfor.DefaultPaymentTermCH,
                    paymentTerms: shipperInfor.PaymentTermsCH,
                    destinationCountriesCH: shipperInfor.DestinationCountryCH,
                    handlingChargeFlg: shipperInfor.HandlingChargeFlg,
                    multiPackageFlg: shipperInfor.MultiPackageFlg
                },
            }

        case AddOrder.CONVERT_NAME_SUCCESS:
            let dataConvert = action.payload.data.data.ConvertedString

            if (typeof dataConvert === 'string') {
                dataConvert = dataConvert.trim()
            }

            if (!dataConvert || (regexJapanese(dataConvert) || regexName(dataConvert))) {
                state.classes.yomigana = 'error'
            } else {
                state.classes.yomigana = ''
            }

            return {
                ...state,
                information: {
                    ...state.information,
                    yomigana: dataConvert.toUpperCase()
                }
            }

        case AddOrder.CONVERT_NAME_FAILS:
            return {
                ...state
            }

        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/reducers/addOrder.js